import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconDocument: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16667 8C9.16667 8.276 8.94267 8.5 8.66667 8.5H4.66667C4.39067 8.5 4.16667 8.276 4.16667 8C4.16667 7.724 4.39067 7.5 4.66667 7.5H8.66667C8.94267 7.5 9.16667 7.724 9.16667 8ZM4.66667 5.83333H6.66667C6.94267 5.83333 7.16667 5.60933 7.16667 5.33333C7.16667 5.05733 6.94267 4.83333 6.66667 4.83333H4.66667C4.39067 4.83333 4.16667 5.05733 4.16667 5.33333C4.16667 5.60933 4.39067 5.83333 4.66667 5.83333ZM8.66667 10.1667H4.66667C4.39067 10.1667 4.16667 10.3907 4.16667 10.6667C4.16667 10.9427 4.39067 11.1667 4.66667 11.1667H8.66667C8.94267 11.1667 9.16667 10.9427 9.16667 10.6667C9.16667 10.3907 8.94267 10.1667 8.66667 10.1667ZM14.5 7.66667V12.6667C14.5 13.678 13.678 14.5 12.6667 14.5H4C2.388 14.5 1.5 13.612 1.5 12V4C1.5 2.388 2.388 1.5 4 1.5H9.33333C10.9453 1.5 11.8333 2.388 11.8333 4V6.16667H13C13.8267 6.16667 14.5 6.83933 14.5 7.66667ZM11.034 13.5C10.906 13.25 10.8333 12.9667 10.8333 12.6667V4C10.8333 2.94867 10.3847 2.5 9.33333 2.5H4C2.94867 2.5 2.5 2.94867 2.5 4V12C2.5 13.0513 2.94867 13.5 4 13.5H11.034ZM13.5 7.66667C13.5 7.39067 13.2753 7.16667 13 7.16667H11.8333V12.6667C11.8333 13.126 12.2073 13.5 12.6667 13.5C13.126 13.5 13.5 13.126 13.5 12.6667V7.66667Z"
      fill={color}
    />
  </svg>
);

export default IconDocument;
